import { gql } from '@apollo/client';

export interface RemoveAssignmentAnswerMutationVariables {
  courseId: string;
  assignmentId: string;
  assignmentAnswerId: string;
}

export interface RemoveAssignmentAnswerMutationResult {
  assignmentAnswer: {
    _id: string;
  };
}

export const removeAssignmentAnswerMutation = gql`
  mutation RemoveAssignmentAnswerMutation($courseId: String!, $assignmentId: String!, $assignmentAnswerId: String!) {
    assignmentAnswer(courseId: $courseId, assignmentId: $assignmentId, assignmentAnswerId: $assignmentAnswerId)
      @rest(
        type: "AssignmentAnswer"
        path: "courses/{args.courseId}/assignments/{args.assignmentId}/answers/{args.assignmentAnswerId}"
        method: "DELETE"
      ) {
      id: _id
    }
  }
`;
